import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import ReadsHero from "@/components/ReadsHero";
import { api, timeAgo } from "@/lib/api";
import { ShareStoryModal, StartTopicModal } from "@/components/Modals";
import { useAuth } from "@/App";

export default function Reads() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [arts, setArts] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [topicOpen, setTopicOpen] = useState(false);

  useEffect(() => { api.get("/articles").then(r=>setArts(r.data||[])); }, []);

  return (
    <div>
      <Navbar onShare={()=>{ if(!user){login();return;} setShareOpen(true); }} onTopic={()=>{ if(!user){login();return;} setTopicOpen(true); }} />
      <div className="reads-wrap">
        <ReadsHero />
        <h1 className="reads-h">LANTEN <em>Reads</em></h1>
        <div className="reads-sub">Curated guides, legal explainers and honest reviews on Indian renting.</div>
        <div className="reads-grid">
          {arts.map(a => (
            <div key={a.id} className="read-tile" data-testid={`read-tile-${a.id}`} onClick={()=>navigate(`/reads/${a.id}`)}>
              {a.cover_image && (
                <div className="read-tile-cover" style={{backgroundImage:`url("${a.cover_image}")`}}/>
              )}
              <div className="read-tile-tag">{a.tag}</div>
              <div className="read-tile-title">{a.title}</div>
              <div className="read-tile-summary">{a.summary}</div>
              <div className="read-tile-meta">{a.author} · {timeAgo(a.created_at)}</div>
            </div>
          ))}
        </div>
      </div>
      <ShareStoryModal open={shareOpen} onClose={()=>setShareOpen(false)} />
      <StartTopicModal open={topicOpen} onClose={()=>setTopicOpen(false)} />
    </div>
  );
}
